import "./header.scss";

import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  title: ReactNode;
  orderHeaderSpan?: ReactNode;
  showHeader?: boolean;
};

function DocumentsList(props: Props) {
  return (
    <div className="documents-list">
      {props.showHeader && (
        <div className="documents-list-header">
          <span className="documents-list-header-title">{props.title}</span>
          {props.orderHeaderSpan}
        </div>
      )}
      <div className="documents-list-items">{props.children}</div>
    </div>
  );
}

export default DocumentsList;
